export default class CreditType {
  public id: number;
  public name: string;
  public hasVenue: boolean;
}
